import {MainHeader, PageWrapperLayout} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {Navigate} from 'react-router-dom';
import {HomeEnum} from 'presentation/constants';
import {useMyHospitalizationLayout} from './hooks/useMyHospitalizationLayout';

const {pageTitle} = translations['pt-br'].privateFlow.myHospitalization;

export const MyHospitalizationLayout = () => {
	const {handleBack, renderBreadcrumbs, renderPageTitle, isEnabled} =
		useMyHospitalizationLayout();

	if (!isEnabled) {
		return <Navigate to={HomeEnum.HOME_PAGE} />;
	}

	return (
		<PageWrapperLayout title={pageTitle}>
			<MainHeader
				title={renderPageTitle()}
				handleBack={handleBack}
				breadcrumbs={renderBreadcrumbs()}
				hideProfileMenu
			/>
		</PageWrapperLayout>
	);
};
